export interface SubmitShortcutEvent {
  altKey: boolean;
  ctrlKey: boolean;
  isComposing: boolean;
  key: string;
  metaKey: boolean;
  repeat: boolean;
  shiftKey: boolean;
}

export function isSubmitShortcut(event: SubmitShortcutEvent): boolean {
  return (
    event.key === "Enter" &&
    (event.ctrlKey || event.metaKey) &&
    !event.altKey &&
    !event.shiftKey &&
    !event.repeat &&
    !event.isComposing
  );
}

export function submitTextareaFormOnShortcut(
  event: React.KeyboardEvent<HTMLTextAreaElement>,
): void {
  if (
    !isSubmitShortcut({
      altKey: event.altKey,
      ctrlKey: event.ctrlKey,
      isComposing: event.nativeEvent.isComposing,
      key: event.key,
      metaKey: event.metaKey,
      repeat: event.repeat,
      shiftKey: event.shiftKey,
    })
  ) {
    return;
  }

  event.preventDefault();
  event.currentTarget.form?.requestSubmit();
}

export function shouldPreventImplicitFormSubmit(event: {
  isComposing: boolean;
  key: string;
}): boolean {
  return event.key === "Enter" && !event.isComposing;
}

/** 単一行入力でEnterを押したときのフォーム暗黙送信を抑止する。 */
export function preventInputFormSubmitOnEnter(event: {
  key: string;
  nativeEvent: { isComposing: boolean };
  preventDefault: () => void;
}): void {
  if (
    !shouldPreventImplicitFormSubmit({
      isComposing: event.nativeEvent.isComposing,
      key: event.key,
    })
  ) {
    return;
  }
  event.preventDefault();
}
